import { gql } from '@apollo/client';

export default gql`
  query billTadweenCustomers {
    billTadweenCustomers {
      ok
      message
      error
    }
  }
`;
